/***
 * Converts edge case where multiple error codes are bound to same translation file
 * @param errorCode The error code from api, usually in query param `error`
 * @return the proper error code
 * **/
export const getErrorCodeFromError = (errorCode: string) => {
  // Both access denied and when error code hd Unautherized should give back translations for
  // UNAUTHORIZED_ACCESS specified in en.json and de.json
  if (errorCode.toLowerCase().includes('unautherized')) {
    // display error message in the same screen if no userIdHint present in the url
    return 'UNAUTHORIZED_ACCESS';
  }
  return errorCode;
};
